import { IconArrowUpRegular } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';

export interface MoreButtonProps {
  visible: boolean;
  onClick: () => void;
  children?: React.ReactNode;
}

export function MoreButton({ visible, onClick, children }: MoreButtonProps) {
  if (visible) {
    return (
      <Wrapper type='button' onClick={onClick} className={Typography.BODY_15_SEMIBOLD}>
        {children}
        <ToggleIcon width={20} height={20} v3Color='gray950' />
      </Wrapper>
    );
  }

  return null;
}

const Wrapper = styled.button`
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${vars.v3Color.staticWhite};
  width: calc(100% - 32px);
  height: 44px;
  border: 1px solid ${vars.v3Color.gray200};
  border-radius: 100px;
`;

const ToggleIcon = styled(IconArrowUpRegular)`
  margin-left: 4px;
  transform: rotate(180deg);
`;
